'use client'

import i18next from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/nl'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { isSSR } from '../next/services/nextjs.rendering'
import { defaultLanguage, i18nConfig, initFormatters } from './config/i18n.config'

const { fallbackLng, languages, defaultNS } = i18nConfig

export function getOptions(lng = defaultLanguage, ns: string | string[] = defaultNS) {
  moment.locale(lng)

  return {
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  }
}

// on client side the normal singleton is ok
i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      const lang = language || defaultLanguage

      return import(`../../../public/locales/${lang}/${namespace}.json`)
    }),
  )
  .init({
    ...getOptions(),
    lng: defaultLanguage,
    detection: {
      order: ['path', 'htmlTag', 'cookie', 'navigator'],
    },
    preload: isSSR ? languages : [],
  })

initFormatters(i18next)

type I18NProviderProps = {
  children: React.ReactNode
}

export function I18nProvider({ children }: I18NProviderProps) {
  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
}
